export default "__VITE_ASSET__ac4f242e__"